import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { IcecontrolSettings } from '../models/icesettings';

@Component({
  selector: 'icediv',
  templateUrl: './icediv.component.html',
  styleUrls: ['./icediv.component.scss']
})
export class IcedivComponent implements OnInit {
  // Input Members
  @Input() placeholder: string = "";
  @Input() id: string = "";
  @Input() properties: any = {};
  @Input() ctrl: IcecontrolSettings = null;

  constructor(private renderer: Renderer2) {
  }

  ngOnInit() {
    let div: HTMLDivElement = <HTMLDivElement>document.getElementById("up");
    div.innerHTML = this.getValue();
  }

  public getDivStyle(): any {
    let style = {
      "width": "100%",
      "color": "black",
      "white-space": this.ctrl.properties.renderAsHTML ? "pre-wrap" : "normal"
    };

    if (this.ctrl == null || this.ctrl.properties == null) return style;

    if (this.ctrl.properties.width != null) {
      style.width = this.ctrl.properties.width;
    }

    if (this.ctrl.properties.color != null) {
      style.color = this.ctrl.properties.color;
    }

    if (this.ctrl.properties.cursor != null) {
      style["cursor"] = this.ctrl.properties.cursor;
    }

    return style;
  }

  getValue(): string {
    if (this.ctrl == null || this.ctrl.properties == null) return "";
    let val: string = this.ctrl.properties.value;
    let Rexp = /(\b(https?|ftp):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\/=~_|!:,.;]*)[-A-Z0-9+&@#\/%=~_|])/ig;

    return val.replace(Rexp,
      "<a href='$1' target='_blank'>$3</a>"); 
  }
}
